import React, { useState } from 'react';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogTrigger } from './ui/dialog';
import { ArrowLeft, ZoomIn } from 'lucide-react';
import CityCard from './CityCard';
import { DECK_INFO } from '../mock/gameData';

const DeckGallery = ({ selectedDeck, onBack }) => {
  const deckInfo = DECK_INFO[selectedDeck];
  const [selectedCard, setSelectedCard] = useState(null);

  if (!deckInfo) return null;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 p-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8 sticky top-0 bg-slate-900/90 backdrop-blur-md z-50 p-4 rounded-b-xl border-b border-white/10 shadow-xl">
          <div className="flex items-center justify-between">
            <Button
              onClick={onBack}
              size="sm"
              variant="outline"
              className="bg-white/10 border-gray-600 text-white hover:bg-white/20"
            >
              <ArrowLeft className="w-4 h-4 mr-1" />
              Back
            </Button>
            
            <div className="text-center flex-1">
              <h1 className="text-3xl font-bold text-white flex items-center justify-center gap-3">
                <span className="text-4xl">{deckInfo.icon}</span>
                {deckInfo.name} Gallery
              </h1>
              <p className="text-gray-400 text-sm mt-1">{deckInfo.cards.length} Cards • {deckInfo.description}</p>
            </div>
            
            <div className="w-[80px]"></div> {/* Spacer for alignment */}
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 pb-12">
          {deckInfo.cards.sort((a, b) => a.rank - b.rank).map((card) => (
            <Dialog key={card.id}>
              <DialogTrigger asChild>
                <div 
                  className="group relative cursor-pointer transform transition-all duration-300 hover:scale-105 hover:z-10"
                  onClick={() => setSelectedCard(card)}
                >
                  <CityCard 
                    card={card} 
                    isPlayable={true} 
                    showRank={true}
                    deckColors={deckInfo.colors}
                    className="w-full aspect-[2/3]"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors rounded-xl flex items-center justify-center opacity-0 group-hover:opacity-100">
                    <ZoomIn className="text-white w-8 h-8 drop-shadow-lg" />
                  </div>
                </div>
              </DialogTrigger>
              <DialogContent className="bg-transparent border-none max-w-sm sm:max-w-md p-0 overflow-hidden shadow-2xl">
                <div className="relative w-full aspect-[2/3]">
                  <CityCard 
                    card={card} 
                    isPlayable={false} 
                    showRank={true}
                    deckColors={deckInfo.colors}
                    className="w-full h-full text-xl"
                  />
                </div>
              </DialogContent>
            </Dialog>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DeckGallery;
